import axios from 'axios';
import { setAlert } from './alert';

import {
  GET_COTATION,
  COTATION_ERROR,
  CLEAR_COTATION,
  UPDATE_COTATION,
  GET_COTATIONS,
  GET_MANUFACTURER,
  GET_MODEL
} from './types';

// Get all cotations
export const getCotations = () => async (dispatch) => {
  dispatch({ type: CLEAR_COTATION });

  try {
    const res = await axios.get('/api/cotation');

    dispatch({
      type: GET_COTATIONS,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: COTATION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

// Get Cotation by ID
export const getCotationById = (cotationId) => async (dispatch) => {
  console.log('cotationId');

  dispatch({ type: CLEAR_COTATION });
  try {
    const res = await axios.get(`/api/cotation/id/${cotationId}`);
    console.log('dsfsdf');

    dispatch({
      type: GET_COTATION,
      payload: res.data
    });
  } catch (err) {
    console.log('sdfdsfsdfsdfsdf');

    dispatch({
      type: COTATION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

// Get all cotations by partial text
export const getCotationsByParams =
  (manufacturer, model, serialnumber, version, generation) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_COTATION });

    try {
      const res = await axios.get(`/api/cotation/custom`, {
        params: {
          manufacturer: manufacturer,
          model: model,
          serialnumber: serialnumber,
          version: version,
          generation: generation
        }
      });

      dispatch({
        type: GET_COTATIONS,
        payload: res.data
      });
    } catch (err) {
      dispatch({
        type: COTATION_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status }
      });
    }
  };

// Get all manufacturers
export const getManufacturers = () => async (dispatch) => {
  // dispatch({ type: CLEAR_COTATION });

  try {
    const res = await axios.get('/api/cotation/distinct/manufacturer');

    console.log(res.data);
    dispatch({
      type: GET_MANUFACTURER,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: COTATION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

// Get all models for a specific manufacturer
export const getModels = (manufacturer) => async (dispatch) => {
  // dispatch({ type: CLEAR_COTATION });

  try {
    const res = await axios.get('/api/cotation/distinct/model', {
      params: {
        manufacturer: manufacturer
      }
    });

    dispatch({
      type: GET_MODEL,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: COTATION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

// Create or update Cotation
export const createCotation = (id, formData, navigate) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    // const res = await axios.post('/api/cotation', formData, config);
    const res = await axios.post(
      id ? `/api/cotation/${id}` : '/api/cotation',
      formData,
      config
    );

    dispatch({
      type: UPDATE_COTATION,
      payload: res.data
    });

    dispatch(setAlert(id ? 'Cotation Updated' : 'Cotation Created', 'success'));

    // setTimeout(() => {
    dispatch({ type: CLEAR_COTATION });
    navigate(`/cotation/${res.data._id}`);
    // }, 2000);
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'danger')));
    }

    dispatch({
      type: COTATION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
    if (id) {
      navigate(`/cotation/${id}`);
    } else {
      navigate(`/recherchecotation/`);
    }
  }
};

//  delete Option
export const deleteCotation = (cotationId) => async (dispatch) => {
  //TODO prevoir traduction anglais
  if (
    window.confirm('Etes vous sur ? Cette opération ne peut pas être annulée !')
  ) {
    try {
      await axios.delete(`/api/cotation/${cotationId}`);

      dispatch({ type: CLEAR_COTATION });

      dispatch(setAlert('Cotation effacée'));
    } catch (err) {
      dispatch({
        type: COTATION_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status }
      });
    }
  }
};

// clearOption
export const clearCotation = () => async (dispatch) => {
  try {
    console.log(CLEAR_COTATION);
    dispatch({ type: CLEAR_COTATION });
  } catch (err) {
    dispatch({
      type: COTATION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};
